export default function getTag(src) {
  return Object.prototype.toString.call(src);
}
